import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const fetchTags = createAsyncThunk(
    "tags/fetchTags",
    async () => {
        const response = await api.get("/filter/tags");
        return response.data;
    }
);


export const fetchTopTags = createAsyncThunk(
    "tags/fetchTopTags",
    async () => {
        const response = await api.get("/tags/fetchTopTags");
        return response.data;
    }
);

export const fetchTagIdByTagName = createAsyncThunk(
    "tags/fetchTagIdByTagName",
    async (tagName) => {
        const response = await api.get("/tags/getTagIdByTagName", {
            params: { tagName }
        });
        return response.data;
    }
);